module.exports = __webpack_public_path__ + "static/media/website-02.dee48705.png";